module.exports = __webpack_public_path__ + "img/97.56b3f8af.jpg";